<template>
  <div class="page">
    <Header :title="titleText" :leftHandler="back" />
    <van-field v-model="form.contactPerson" label="收货人" placeholder="请输入收货人姓名" />
    <van-field v-model="form.contactMobile" placeholder="请输入联系电话" >
      <template #label>
        <div style="display: flex; flex-direction: row; width: 4rem;">
          <span style="margin-right: 0.2rem;">联系电话</span><span @click="popupShow2 = true"> {{ form.iddCode }}<img style="width: 0.3rem; height: 0.17rem; margin: 0 0 0.04rem 0.1rem;" src="https://boshi2023.oss-cn-shanghai.aliyuncs.com/img/Polygon.png" alt="" ></span>
        </div>
      </template>
    </van-field>
    <van-cell title="所在地区" :value="location" is-link @click="popupShow = true" >
      <template #label>
        <span class="color-red" v-show="!form.cityId">请选择所在市</span>
    </template>
    </van-cell>
    <van-field v-model="form.detailAddress" rows="4" type="textarea" placeholder="请填写详细地址"  maxlength="50"  show-word-limit />
    <van-cell title="设为默认">
      <template #right-icon>
        <van-checkbox checked-color="#00545e" v-model="form.isDefault">
        </van-checkbox>
      </template>
    </van-cell>
    <van-field v-model="form.getCode" center clearable label="验证码" placeholder="请输入短信验证码">
      <template #button>
        <van-button size="small" type="primary" @click="getCode" v-if="!isGeting">获取验证码</van-button>
        <van-button size="small" type="primary" v-if="isGeting">{{ countdown }}s</van-button>
      </template>
    </van-field>
    <div class="text-center">
      <van-button type="primary" class="center-personal-data-submit" @click="apply">提交申请</van-button>
    </div>
    <van-popup v-model="popupShow" round position="bottom">
      <van-cascader v-model="form.countyId" title="请选择所在地区" :options="options" @finish="finish" @change="change"
        :field-names="fieldNames" @close="close()" />
    </van-popup>
    <van-popup v-model="popupShow2" round position="bottom">
      <van-picker show-toolbar :columns="phoneArray"  @confirm="onConfirm" @cancel="onCancel"/>
    </van-popup>
  </div>
</template>

<script>
import Header from '@/components/header'
import activityApi from '@/api/activity'
import baseApi from '@/api/base'
import { mapState } from 'vuex'
export default {
  components: {
    Header
  },
  data () {
    return {
      address: {},
      titleText: '新增地址',
      form: {
        addressId: '',
        contactPerson: '',
        contactMobile: '',
        cityId: '',
        countyId: '',
        provinceId: '',
        isDefault: '',
        zipCode: '',
        detailAddress: '',
        getCode: '',
        iddCode: '+86'
      },
      isGeting: false,
      countdown: 60,
      popupShow: false,
      popupShow2: false,
      fieldNames: {
        text: 'name',
        value: 'id',
        children: 'child'
      },
      options: [],
      location: '',
      selectCouponId: 0,
      selectAddress: '',
      hasCounty: false,
      phoneArray: [ '中国大陆 +86', '中国香港 +852', '中国澳门 +853', '中国台湾 +886' ]
    }
  },
  created () {
    this.selectCouponId = this.$route.params.couponId || 0
    this.selectAddress = this.$route.params.selectAddress
    if (this.userRole === '03') {
      this.$toast('没有修改收货地址的权限')
    } else {
      this.init()
    }
  },
  computed: {
    ...mapState({
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    })
  },
  methods: {
    onConfirm (e) {
      this.form.iddCode = e.substr(5)
      this.popupShow2 = false
    },
    onCancel () {
      this.popupShow2 = false
    },
    init () {
      this.addressId = this.$route.params.addressId || ''
      if (this.$route.params.addressId) {
        this.titleText = '修改地址'
        for (const key in this.form) {
          this.form[key] = this.$route.params[key]
        }
        if (!this.form.iddCode) { this.form.iddCode = '+86' }
      } else {
        this.titleText = '新增地址'
      }
      console.log(this.form)
      this.getDistrictList()
    },
    getDistrictList () {
      baseApi.getDistrictList().then(res => {
        if (res.data.resultCode === '0') {
          this.options = res.data.resultData.data
          if (this.addressId && this.options && this.options.length) {
            let province = this.options.find(item => {
              return item.id === this.form.provinceId
            })
            let city = province.child.find(item => {
              return item.id === this.form.cityId
            })
            let county = city.child.find(item => {
              return item.id === this.form.countyId
            })
            const countyName = (county && county.name) || ''
            this.location = province.name + city.name + countyName
          }
        }
      })
    },
    finish (value) {
      // this.form.provinceId = value.selectedOptions[0].id
      // this.form.cityId = value.selectedOptions[1].id
      // this.form.countyId = value.selectedOptions[2].id
      // this.location = value.selectedOptions[0].name + value.selectedOptions[1].name + value.selectedOptions[2].name
      this.popupShow = false
    },
    validatePhoneNumber (phoneNumber) {
      const that = this
      // 手机号正则表达式
      let phoneRegEx
      if (that.form.iddCode === '+86') {
        phoneRegEx = /^1[3456789]\d{9}$/
        return phoneRegEx.test(phoneNumber)
      } else if (that.form.iddCode === '+852' || that.form.iddCode === '+853') {
        phoneRegEx = /^\d{8}$/
        return phoneRegEx.test(phoneNumber)
      } else if (that.form.iddCode === '+886') {
        phoneRegEx = /^\d{9}$/
        return phoneRegEx.test(phoneNumber)
      }
    },
    // 提交
    apply () {
      if (!this.validatePhoneNumber(this.form.contactMobile)) {
        this.$toast('请选择正确的手机区号！')
        return
      }
      if (!this.checkApplyData()) return
      const data = {
        addressInfo: {
          provinceId: this.form.provinceId,
          cityId: this.form.cityId,
          countyId: this.hasCounty ? this.form.countyId : '',
          detailAddress: this.form.detailAddress,
          isDefault: this.form.isDefault ? 1 : 0,
          contactPerson: this.form.contactPerson,
          contactMobile: this.form.contactMobile,
          contactPhone: '',
          contactEmail: '',
          zipCode: ''
        },
        verifyCode: this.form.getCode
      }
      if (this.$route.params.addressId) {
        // 修改
        data.addressInfo.addressId = this.addressId
        activityApi.updateAddress(data).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('修改成功')
            this.$router.replace({
              name: 'receivingAddress',
              params: {
                selectAddress: this.$route.params.selectAddress,
                selectCouponId: this.$route.params.couponId
              }
            })
          }
        })
      } else {
        // 新增
        activityApi.createAddress(data).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('新增地址成功')
            // this.$router.go(-1)
            this.$router.replace({
              name: 'receivingAddress',
              params: {
                selectAddress: this.$route.params.selectAddress,
                selectCouponId: this.$route.params.couponId
              }
            })
          }
        })
      }
    },
    // 获取验证码
    getCode () {
      if (!this.isGeting) {
        let that = this
        activityApi.getAddressVerifyCode().then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('验证码已发送，请注意查收')
            this.isGeting = true
            var timer = setInterval(function () {
              if (that.countdown > 0) {
                that.countdown--
              } else {
                clearInterval(timer)
                that.isGeting = false
                that.countdown = 60
              }
            }, 1000)
          }
        })
      }
    },
    checkApplyData () {
      if (!this.form.contactPerson) {
        this.$toast('请填写收货人')
        return false
      }
      if (!this.form.contactMobile) {
        this.$toast('请填写联系电话')
        return false
      } else if (!/^(1[3-9]\d{9})$|^(\d{8})$|^(\d{9})$/.test(this.form.contactMobile)) {
        this.$toast('请填写正确的手机号')
        return false
      }
      if (!this.location) {
        this.$toast('请填写所在地区')
        return false
      }
      if (!this.form.cityId) {
        this.$toast('请选择所在市')
        return false
      }
      if (!this.form.detailAddress) {
        this.$toast('请填写详细地址')
        return false
      }
      if (!this.form.getCode) {
        this.$toast('请填写验证码')
        return false
      }
      return true
    },
    back () {
      this.$router.replace({
        name: 'receivingAddress',
        params: {
          selectAddress: this.$route.params.selectAddress,
          selectCouponId: this.$route.params.couponId
        }
      })
    },
    close () {
      this.popupShow = false
    },
    change (data) {
      const { selectedOptions, tabIndex } = data
      switch (tabIndex) {
        case 0:
          this.form.provinceId = selectedOptions[0].id
          this.form.cityId = ''
          this.location = selectedOptions[0].name
          this.hasCounty = false
          break
        case 1:
          this.form.cityId = selectedOptions[1].id
          this.hasCounty = false
          this.location = selectedOptions[0].name + selectedOptions[1].name || ''
          break
        case 2:
          this.form.countyId = selectedOptions[2].id
          this.hasCounty = true
          const provinceCityName = selectedOptions[0].name + selectedOptions[1].name
          this.location = provinceCityName + selectedOptions[2].name || ''
          break
        default:
          break
      }
    }
  }
}
</script>
<style scoped lang="less">
.center-personal-data-submit {
  width: 80%;
  margin: 0.5rem auto 0 auto
}

.van-cascader /deep/ .van-tabs__content {
  min-height: auto;
}
/deep/ .van-field__label{
  width: 8.2em !important;
}
.color-red{
  color:#e41b2c;
}
</style>
